import React from 'react';
import RecruiterSupportCardWrapper from './RecruiterSupportCardWrapper';
import AccountManagers from './AccountManagers';
import MoreOptions from './MoreOptions';
import { useGetPositionsForRecruiterQuery } from 'src/hooks/position.hooks';
import { AccountManagerForCompany } from 'types';
import { useUserContext } from 'src/context/UserProvider';
import { Loader } from 'ui';
import Container from 'src/components/shared/Container';

export const RecruiterSupport = () => {
	const { isAccountManagerLoggedIn } = useUserContext();
	const { data: positionsData, isLoading: isPositionsDataLoading } = useGetPositionsForRecruiterQuery(
		isAccountManagerLoggedIn,
		'',
	);
	let accountManagers: AccountManagerForCompany[] = [];
	if (positionsData && positionsData.accountManagers?.length) {
		accountManagers = positionsData.accountManagers || [];
	}

	if (isPositionsDataLoading) return <Loader />;
	return (
		<Container className="p-[16px] grid gap-[16px] md:grid-cols-2 ">
			{isAccountManagerLoggedIn ? null : (
				<RecruiterSupportCardWrapper title="Account managers">
					<AccountManagers accountManagers={accountManagers} />
				</RecruiterSupportCardWrapper>
			)}
			<RecruiterSupportCardWrapper title="More">
				<MoreOptions />
			</RecruiterSupportCardWrapper>
		</Container>
	);
};
